<div id="member-filter-section" class="custom-ng-select-container">
    <ng-select
      [items]="items"
      [multiple]="multiselect"
      [loading]="loading"
      [bindLabel]="bindLabel"
      [(ngModel)]="selectedItems"
      [searchable]="true"
      [clearSearchOnAdd]="true"
      [ngModelOptions]="{standalone: true}"
      [disabled]="disabled"
      (clear)="clearSelection()"
      (change)="emitSelection()"
      dropdownPosition="bottom"
      notFoundText="{{'Nothinghere' | localize}}"
      [placeholder]="placeholder"
      [closeOnSelect]="closeOnSelect">

        <!-- Label template -->
        <ng-template ng-label-tmp let-item="item" *ngIf="!multiselect">
            <span class="d-flex align-items-center">
                <img height="17" width="17" class="mr-1 border border-light rounded p-1" [src]="item.projectImage"/>
                <span *ngIf="!isSlice" pTooltip="{{ item.name }}" [tooltipDisabled]="showTooltipForString(item.name, 68)" tooltipPosition="bottom">{{ item.name | slice:0:60 }}{{ item.name.length > 60 ? '...' : '' }}</span>
                <span *ngIf="isSlice" pTooltip="{{ item.name }}" [tooltipDisabled]="showTooltipForString(item.name, 68)" tooltipPosition="bottom">{{ item.name | slice:0:15 }}{{ item.name.length > 15 ? '...' : '' }}</span>
            </span>
        </ng-template>

        <!-- Multi label -->
        <ng-template ng-multi-label-tmp let-items="items" *ngIf="multiselect" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items | slice:0:1; trackBy: trackByName">
                <span class="ng-value-label d-flex align-items-center">
                    <img height="17" width="17" class="mr-1 border border-light rounded p-1" [src]="item.projectImage"/>
                    <span pTooltip="{{ item.name }}" [tooltipDisabled]="showTooltipForString(item.name, 10)" tooltipPosition="bottom">{{ item.name | slice:0:10 }}{{ item.name.length > 10 ? '...' : '' }}</span>
                    <span class="ng-value-icon right ml-3" (click)="clear(item)" aria-hidden="true">×</span>
                </span>
            </div>
            <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">{{items.length - 1}} {{'More' | localize}}...</span>
            </div>
        </ng-template>

        <!-- Multiselet Option template -->
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" *ngIf="multiselect">
            <div class="d-flex">
                <div class="checkbox  mr-2">
                    <input id="item-{{index}}" name="item-{{index}}"  type="checkbox" [ngModel]="item$.selected"
                        />
                        <span (click)="checkUncheck(item$.selected)"></span>
                </div>
                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1" style="width: 40px; height: 40px;">
                    <img src="{{ item.projectImage }}" class="img-fluid border border-light rounded p-1 h-40px w-40px" id="profimgsize">
                </div>
                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75" style="width: calc(100% - 88px);">
                    <div class="font-weight-bold w-100"><div pTooltip="{{ item.name }}" [tooltipDisabled]="showTooltipForString(item.name, maximumProjectNameLengthTooltipMultiselect)" tooltipPosition="bottom" style="z-index: 10000;" class="long-name">{{ item.name }}</div></div>

                </div>
            </div>
        </ng-template>

        <!-- Option template -->
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" *ngIf="!multiselect">
            <div class="d-flex">
                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1" style="width: 40px; height: 40px;">
                    <img src="{{ item.projectImage }}" class="img-fluid border border-light rounded p-1 h-40px w-40px" id="profimgsize">
                </div>
                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                    <div class="font-weight-bold"><span pTooltip="{{ item.name }}" [tooltipDisabled]="showTooltipForString(item.name, 10)" tooltipPosition="bottom">{{ item.name | slice:0:10 }}{{ item.name.length > 10 ? '...' : '' }}</span></div>
                </div>
            </div>
        </ng-template>

        <!-- Header template -->
        <ng-template ng-header-tmp *ngIf="multiselect && items && items.length">
        <div class="d-flex cursor-pointer" (click)="showselectall ? selectAll(): unselectAll()">
            <label *ngIf="showselectall" class="checkbox ml-1 mr-2">
                <input id="item" name="item"  type="checkbox" [ngModel]="!showselectall" (ngModelChange)="showselectall = $event"
                    />
                <span ></span>
            </label>
            <label *ngIf="showdeselectall" class="checkbox ml-1 mr-2">
                <input id="item" name="item"  type="checkbox" [ngModel]="!showselectall" (ngModelChange)="showselectall = $event"
                    />
                <span></span>
            </label>
            <span *ngIf="showselectall" class="pointer my-2">{{'Selectall' | localize}}</span>
            <span *ngIf="showdeselectall" class="pointer my-2">{{'Selectall' | localize}}</span>
        </div>
        </ng-template>

        <!-- Footer template -->
        <ng-template *ngIf="multiselect && items && items.length" ng-footer-tmp>
            <div class="text-muted" style="font-size: 0.8rem;">{{ selectedItems ? selectedItems.length : '0' }} {{ selectedItems && (selectedItems.length === 0 || selectedItems.length > 1) ? ('items' | localize) : 'Item' | localize}} {{'selected' | localize}}</div>
        </ng-template>

        <!-- Loader template -->
        <ng-template ng-loadingspinner-tmp>
            <div class="spinner spinner-primary mr-7"></div>
        </ng-template>

        <!-- Loading template -->
        <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled d-flex justify-content-center align-items-center">
                <div class="spinner spinner-primary my-4"></div>
            </div>
        </ng-template>

        <!-- Type to search -->
        <ng-template ng-typetosearch-tmp>
            <div class="ng-option disabled">
                {{'Starttyping' | localize}}...
            </div>
        </ng-template>

        <!-- Not found -->
        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled">
                {{'Nodatafoundfor' | localize}} "{{searchTerm}}"
            </div>
        </ng-template>

    </ng-select>
  </div>
